module.exports = __webpack_public_path__ + "img/logistics_image_full.53cb7a7c.jpg";